import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { fetchSingleLot } from "../../../redux/actions/immobilierActions";
import mainAxios from "../../../redux/api/mainAxios";
import toast from "react-hot-toast";

const EditLotModal = ({ lot }) => {
  const dispatch = useDispatch();

  const [formData, setFormData] = useState({
    reference: lot.reference || "",
    typology: lot.typology || "",
    price_total: lot.price_total || "",
    rent: lot.rent || "",
    rent_profitability: lot.rent_profitability || "",
    surface: lot.surface || "",
    weighted_surface: lot.weighted_surface || "",
    floor: lot.floor || "",
    orientations: lot.orientations || "",
    commission: lot.commission || "",
  });

  const [isFormValid, setIsFormValid] = useState(false);

  useEffect(() => {
    const isValid = Object.values(formData).every((value) => value !== "");
    setIsFormValid(isValid);
  }, [formData]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleEditLot = async () => {
    try {
      const response = await mainAxios.put(
        `${process.env.REACT_APP_ENDPOINT_URL}api/lots/${lot.documentId}`,
        {
          data: {
            ...formData,
            orientations: JSON.stringify([formData.orientations]),
            commission: formData.commission,
          },
        }
      );
      toast.success("Lot mis à jour avec succès");
      dispatch(fetchSingleLot(lot.documentId));
    } catch (error) {
      console.error("error", error.response.data.error.name);
      toast.error("Echec de la mise à jour du lot");
    }
  };

  return (
    <div className="w100 d-flex flex-column">
      <div>
        <p className="semibold pink fs16">Fiche du lot</p>
        <hr />
      </div>
      <div className="d-flex gap40">
        {/* Left Column */}
        <div className="w50 d-flex flex-column gap20">
          <div>
            <p className="medium darkGrey fs12 mb-10">Reference</p>
            <input
              type="text"
              name="reference"
              value={formData.reference}
              onChange={handleChange}
              className="w100 customInput"
            />
          </div>
          <div>
            <p className="medium darkGrey fs12 mb-10">Prix</p>
            <input
              type="text"
              name="price_total"
              value={formData.price_total}
              onChange={handleChange}
              className="w100 customInput"
            />
          </div>
          <div>
            <p className="medium darkGrey fs12 mb-10">Surface</p>
            <input
              type="text"
              name="surface"
              value={formData.surface}
              onChange={handleChange}
              className="w100 customInput"
            />
          </div>
          <div>
            <p className="medium darkGrey fs12 mb-10">Étage</p>
            <input
              type="text"
              name="floor"
              value={formData.floor}
              onChange={handleChange}
              className="w100 customInput"
            />
          </div>
          <div>
            <p className="medium darkGrey fs12 mb-10">Commission</p>
            <input
              type="text"
              name="commission"
              value={formData.commission}
              onChange={handleChange}
              className="w100 customInput"
            />
          </div>
        </div>

        {/* Right Column */}
        <div className="w50 d-flex flex-column gap20">
          <div>
            <p className="medium darkGrey fs12 mb-10">Typology</p>
            <input
              type="text"
              name="typology"
              value={formData.typology}
              onChange={handleChange}
              className="w100 customInput"
            />
          </div>
          <div>
            <p className="medium darkGrey fs12 mb-10">Loyer</p>
            <input
              type="text"
              name="rent"
              value={formData.rent}
              onChange={handleChange}
              className="w100 customInput"
            />
          </div>
          <div>
            <p className="medium darkGrey fs12 mb-10">Surface Habitable</p>
            <input
              type="text"
              name="weighted_surface"
              value={formData.weighted_surface}
              onChange={handleChange}
              className="w100 customInput"
            />
          </div>
          <div>
            <p className="medium darkGrey fs12 mb-10">Orientations</p>
            <input
              type="text"
              name="orientations"
              value={formData.orientations}
              onChange={handleChange}
              className="w100 customInput"
            />
          </div>
          <div>
            <p className="medium darkGrey fs12 mb-10">Rentabilité</p>
            <input
              type="text"
              name="rent_profitability"
              value={formData.rent_profitability}
              onChange={handleChange}
              className="w100 customInput"
            />
          </div>
        </div>
      </div>
      <div className="d-flex justify-content-end mt-20">
        <button
          onClick={handleEditLot}
          disabled={!isFormValid}
          className={`radius5 px-20 py-1 white border-0 hoverOpacity ${
            isFormValid ? "bg-pink" : "bg-soft-grey"
          }`}
        >
          Appliquer
        </button>
      </div>
    </div>
  );
};

export default EditLotModal;
